import { Grid } from '@mui/material';
import { CallToAction } from '@peerless/data-access/strapi';
import { formatPosition } from '../utils';
import { CallToActionButton } from './CallToActionButton';

interface Props {
  callToAction?: CallToAction;
}

export function CallToActionSection({ callToAction }: Props) {
  if (!callToAction || Object.keys(callToAction).length === 0) return null;
  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: formatPosition(callToAction.buttonAlignment),
      }}
      container
      spacing={2}
    >
      {callToAction.callToActionButtons?.map(button => {
        return (
          <Grid key={`call-to-action-${button.id}`} item xs={12} sm={6} md={4} lg={3}>
            <CallToActionButton callToAction={button} />
          </Grid>
        );
      })}
    </Grid>
  );
}
